import { render, staticRenderFns } from "./p10.vue?vue&type=template&id=d42997e2&scoped=true&"
import script from "./p10.vue?vue&type=script&lang=js&"
export * from "./p10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42997e2",
  null
  
)

export default component.exports